import { motion, AnimatePresence } from "framer-motion";

const ChatAnimations = ({ showBlueberryAnim, setShowBlueberryAnim, showCarrotAnim, setShowCarrotAnim }) => (
  <>
    <AnimatePresence>
      {showBlueberryAnim && (
        <motion.div initial={{ opacity: 0, scale: 0.5 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.5 }}
          className="flex justify-center my-2" data-testid="blueberry-animation">
          <video autoPlay muted playsInline className="w-48 h-48 rounded-2xl" onEnded={() => setShowBlueberryAnim(false)}>
            <source src="https://customer-assets.emergentagent.com/job_scent-select-bunny/artifacts/r3nd3gwc_Blueberry.mp4" type="video/mp4" />
          </video>
        </motion.div>
      )}
    </AnimatePresence>
    <AnimatePresence>
      {showCarrotAnim && (
        <motion.div initial={{ opacity: 0, scale: 0.5 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.5 }}
          className="flex justify-center my-2" data-testid="carrot-animation">
          <video autoPlay muted playsInline className="w-48 h-48 rounded-2xl" onEnded={() => setShowCarrotAnim(false)}>
            <source src="https://customer-assets.emergentagent.com/job_scent-select-bunny/artifacts/porrjnn1_Carrot_Animation.mp4" type="video/mp4" />
          </video>
        </motion.div>
      )}
    </AnimatePresence>
  </>
);

export default ChatAnimations;
